export default __webpack_public_path__ + "static/media/2c5b12c8f2a18b2a.5e9d2f123309de22473aa650f9419cc5.svg";